import axios from "axios";
import { GestionURL, XapiURL } from "../APIs/api-xibo";

export async function DisplaysProofs(scheduleRes, mediaName, cookies, target) {
  const Xpress = axios.create({
    baseURL: `${XapiURL}/api`,
    withCredentials: true,
    crossDomain: true,
    origin: GestionURL,
  });
  // let clientIp = await GetIpClient();
  let videoName = mediaName;
  const current = new Date();
  const date = `${current.getDate()}/${
    current.getMonth() + 1
  }/${current.getFullYear()}`;
  const time =
    current.getHours() +
    ":" +
    current.getMinutes() +
    ":" +
    current.getSeconds();

  try {
    const proof = await Xpress.post(
      `/proof/new?userID=${cookies.user.userId}&userName=${cookies.user.userName}&videoID=${target.videoId}&videoName=${videoName}&date=${time} - ${date}&displayGroupID=${scheduleRes.data.displayGroups[0].displayGroupId}&displayGroupName=${scheduleRes.data.displayGroups[0].displayGroup}`
    );
    if (proof.status === 201 || proof.status === 200) {
      return true;
    } else {
      return "Proof not created";
    }
  } catch (error) {
    return error;
  }
}

export async function StopDisplaysProofs(mediaID, mediaName, cookies) {
  const Xpress = axios.create({
    baseURL: `${XapiURL}/api`,
    withCredentials: true,
    crossDomain: true,
    origin: GestionURL,
  });
  // let clientIp = await GetIpClient();

  try {
    const proof = await Xpress.post(
      `/proof/stop?userID=${cookies.user.userId}&userName=${cookies.user.userName}&videoID=${mediaID}&videoName=${mediaName}`
    );
    if (proof.status === 201 || proof.status === 200) {
      return true;
    } else {
      return "Proof not created";
    }
  } catch (error) {
    return error;
  }
}
